import { Link } from "react-router-dom";
import "./PrivateArea.css";
import { useTranslation } from "react-i18next";

function Unauthorized() {
  const { t } = useTranslation();
  return (
    <div className="unauthorized-container">
      <h1>{t("unauthorized.title")}</h1>
      <p>{t("unauthorized.message")}</p>
      <Link to="/home" className="unauthorized-link">
        {t("unauthorized.backHome")}
      </Link>
    </div>
  );
}

export default Unauthorized;
